export function getAdDescription(pVideoInfo, pAdInfo = null) {
  if (null === pAdInfo || pVideoInfo === null) {
    return;
  }
  const {
    type,
    elementURL,
    mediaURL,
    number,
  } = pAdInfo;

  const result = {
    type: type,
    source: elementURL,
    creative_url: mediaURL,
    advert_url: pVideoInfo.advert_url,
    creative_position: number
  };

  return {
    player_ad: result,
  };
}
